module.exports = __webpack_public_path__ + "static/media/image_A10.fad49b0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog_images/image_A10.jpg
// module id = 2256
// module chunks = 0